var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 55.5C43.4117 55.5 55.5 43.4117 55.5 28.5C55.5 13.5883 43.4117 1.5 28.5 1.5C13.5883 1.5 1.5 13.5883 1.5 28.5C1.5 43.4117 13.5883 55.5 28.5 55.5Z",
    fill: "url(#paint0_linear_428_168)",
    stroke: "#CBA66E",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M28.5 48.5C39.5457 48.5 48.5 39.5457 48.5 28.5C48.5 17.4543 39.5457 8.5 28.5 8.5C17.4543 8.5 8.5 17.4543 8.5 28.5C8.5 39.5457 17.4543 48.5 28.5 48.5Z",
    stroke: "#CBA66E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.5V30.5L39.5 37.5",
    stroke: "#D2922C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31.5C30.1569 31.5 31.5 30.1569 31.5 28.5C31.5 26.8431 30.1569 25.5 28.5 25.5C26.8431 25.5 25.5 26.8431 25.5 28.5C25.5 30.1569 26.8431 31.5 28.5 31.5Z",
    fill: "#D2922C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_428_168",
    x1: 1.5,
    y1: 1.5,
    x2: 55.5,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#330804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#52170C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90291B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.b1254b77868f2cf8e834887dd04bc9cf.svg";
export { ForwardRef as ReactComponent };